import { AdministrativeAgent } from 'pages/AdministrativeAgent/AdministrativeAgent';

export default AdministrativeAgent;
